/* External Imports */
import { Box, Flex } from '@chakra-ui/react';
import { useMediaQuery } from 'react-responsive';

/* Internal Imports */
/* Components */
import WhoThisCards from '@app-ila/components/Card/WhoThisCards';
import SectionTitle from '@app-ila/components/Text/SectionTitle';

/**
 *
 * @param {Object} sectionContent
 * @returns
 */
const HMMWhoThis = ({ sectionContent }) => {
  const isSmallScreen = useMediaQuery({ maxWidth: 480 });

  return (
    <Box padding={0} pb={{ base: '30px', md: '40px', lg: '60px' }}>
      <Box
        maxW={{
          base: '100%',
          sm: '540px',
          md: '720px',
          lg: '960px',
          xl: '1170px',
          '2xl': '1330px',
        }}
        mx="auto"
        width="100%"
        position="relative"
      >
        <Flex
          flexDirection="column"
          position="relative"
          mb="20px"
          pt="60px"
          pl="16px"
        >
          <SectionTitle titleObj={sectionContent[0]} />
        </Flex>
      </Box>
      <WhoThisCards cards={sectionContent[1].cards} />
    </Box>
  );
};

export default HMMWhoThis;
